// 可以在这定义一些常用的表单校验规则

const strlen = (str) => {
  // 参数校验，如果为空则返回0
  if (!str || typeof str !== 'string') {
    return 0;
  }

  let len = 0;
  for (var i = 0; i < str.length; i++) {
    const c = str.charCodeAt(i);
    //单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      len++;
    } else {
      len += 2;
    }
  }
  return len;
};
//!(/^1[3456789]\\d{9}$/.test(phone)
const mobile = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入'));
  } else {
    if (!isNaN(value) && /^1[3456789]\d{9}$/.test(value)) {
      //if (!/^([0-1]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/.test(value)) {
      callback();
    } else {
      callback(new Error('请输入正确的手机号码'));
    }
  }
};

const parsePhone = (phone) => {
  if (phone) {
    let arr = phone.split(' ');
    return arr.join('');
  } else {
    return '';
  }
};

const checkPhone = (rule, value, callback) => {
  let reg_tel =
    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
  if (reg_tel.test(parsePhone(value))) {
    callback();
  } else {
    callback(new Error('请输入正确的手机号码'));
  }
};

const checkPhoneOrEmail = (rule, value, callback) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (emailRegex.test(value)) {
    callback();
  } else {
    checkPhone(rule, value, (e) => {
      callback(e && new Error('请输入正确的联系方式'));
    });
  }
};

const checkPhoneCanNull = (rule, value, callback) => {
  let reg_tel =
    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
  if (reg_tel.test(parsePhone(value)) || value.length === 0) {
    callback();
  } else {
    callback(new Error('请输入正确的手机号码'));
  }
};

const isNum = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入'));
  } else {
    if (/^[0-9]*$/.test(value)) {
      //if (!/^([0-1]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/.test(value)) {
      callback();
    } else {
      callback(new Error('必须数字类型'));
    }
  }
};

const charLen =
  (num, canNull = false) =>
  (rule, value, callback) => {
    if (value === '' || value == null) {
      if (!canNull) {
        callback(new Error('请输入'));
      } else {
        callback();
      }
    } else {
      const len = strlen(value);
      if (len <= num * 2) {
        callback();
      } else {
        callback(new Error(`最多${num}个字（2个英文算一个)`));
      }
    }
  };
const validatorVideoTime = (rule, value, callback) => {
  if (value === '') {
    callback(new Error('请输入'));
  } else {
    value = +value;
    if (!isNaN(value) && value >= 0) {
      //if (!/^([0-1]?[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/.test(value)) {
      callback();
    } else {
      callback(new Error('时间不正确'));
    }
  }
};
const tagslength =
  (count = 3, min = 2, max = 8, none = false) =>
  (rule, value, callback) => {
    if (!none && value.length == 0) {
      callback(new Error('至少输入一个标签'));
    } else {
      // console.log(count, min, max)
      var lenErr = true,
        msg = '';
      if (value.length > count) {
        lenErr = false;
        msg = `标签个数最多${count}个`;
      } else {
        for (let i in value) {
          const len = strlen(value[i]);
          if (len > 16) {
            lenErr = false;
            msg = `标签名长度不能超过${max}！`;
          }
          if (len < 4) {
            lenErr = false;
            msg = `标签名长度不能小于${min}！`;
          }
        }
      }
      if (!lenErr) {
        callback(new Error(msg));
      } else {
        callback();
      }
    }
  };

const textLen =
  (min, max, isNeed = true) =>
  (rule, value, callback) => {
    const len = strlen(value);
    if ((len >= min * 2 && len <= max * 2) || (!isNeed && len == 0)) {
      callback();
    } else {
      let msg = '';
      if (len < min * 2) msg = `最少${min}个字（2个英文算一个)`;
      if (len > max * 2) msg = `最多${max}个字（2个英文算一个)`;
      callback(new Error(msg));
    }
  };

const isTrue = (rule, value, callback) => {
  if (value) {
    callback();
  } else {
    callback(new Error('请置true'));
  }
};

const checkSocialCreditCode = (rule, value, callback) => {
  let patrn = /^[0-9A-Z]+$/;
  //18位校验及大写校验
  if (value.length != 18 || patrn.test(value) == false) {
    callback(new Error('请输入有效的统一社会信用代码'));
  } else {
    let Ancode; //统一社会信用代码的每一个值
    let Ancodevalue; //统一社会信用代码每一个值的权重
    let total = 0;
    let weightedfactors = [
      1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28,
    ]; //加权因子
    let str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
    //不用I、O、S、V、Z
    for (let i = 0; i < value.length - 1; i++) {
      Ancode = value.substring(i, i + 1);
      Ancodevalue = str.indexOf(Ancode);
      total = total + Ancodevalue * weightedfactors[i];
      //权重与加权因子相乘之和
    }
    let logiccheckcode = 31 - (total % 31);
    if (logiccheckcode == 31) {
      logiccheckcode = 0;
    }
    let Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y';
    let Array_Str = Str.split(',');
    logiccheckcode = Array_Str[logiccheckcode];

    let checkcode = value.substring(17, 18);
    if (logiccheckcode != checkcode) {
      callback(new Error('请输入有效的统一社会信用代码'));
    }
    callback();
  }
};
const checkVerCode = (rule, value, callback) => {
  let reg_user = /^([0-9]|[a-z]|[A-Z]){4,6}$/; //4-6个数字正则
  if (reg_user.test(value)) {
    callback();
  } else {
    callback(new Error('验证码只能有4-6个数字'));
  }
};

const checkMobileVerCode = (rule, value, callback) => {
  let reg_user = /^[0-9]{4,6}$/; //4-6个数字正则
  if (reg_user.test(value)) {
    callback();
  } else {
    callback(new Error('验证码只能有4-6个数字'));
  }
};

//15位转18位身份证号
function changeFivteenToEighteen(card) {
  if (card.length === 15) {
    let arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    let arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    let cardTemp = 0,
      i;
    card = card.substr(0, 6) + '19' + card.substr(6, card.length - 6);
    for (i = 0; i < 17; i++) {
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    card += arrCh[cardTemp % 11];
    return card;
  }
  return card;
}

//校验位的检测
function checkParity(card) {
  //15位转18位
  card = changeFivteenToEighteen(card);
  let len = card.length;
  if (len === 18) {
    let arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    let arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    let cardTemp = 0,
      i,
      valnum;
    for (i = 0; i < 17; i++) {
      cardTemp += card.substr(i, 1) * arrInt[i];
    }
    valnum = arrCh[cardTemp % 11];
    if (valnum == card.substr(17, 1)) {
      console.log('checkParity', true);
      return true;
    }
    return false;
  }
  return false;
}

const idCard = (rule, code, callback) => {
  // var city = {
  //     11: '北京',
  //     12: '天津',
  //     13: '河北',
  //     14: '山西',
  //     15: '内蒙古',
  //     21: '辽宁',
  //     22: '吉林',
  //     23: '黑龙江 ',
  //     31: '上海',
  //     32: '江苏',
  //     33: '浙江',
  //     34: '安徽',
  //     35: '福建',
  //     36: '江西',
  //     37: '山东',
  //     41: '河南',
  //     42: '湖北 ',
  //     43: '湖南',
  //     44: '广东',
  //     45: '广西',
  //     46: '海南',
  //     50: '重庆',
  //     51: '四川',
  //     52: '贵州',
  //     53: '云南',
  //     54: '西藏 ',
  //     61: '陕西',
  //     62: '甘肃',
  //     63: '青海',
  //     64: '宁夏',
  //     65: '新疆',
  //     71: '台湾',
  //     81: '香港',
  //     82: '澳门',
  //     91: '国外 '
  // }
  var tip = '';
  var pass = true;

  if (
    !code ||
    !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
      code
    )
  ) {
    tip = '身份证号格式错误';
    pass = false;
  }
  // else if (!city[code.substr(0, 2)]) {
  //     tip = '地址编码错误'
  //     pass = false
  // }
  else {
    // 18位身份证需要验证最后一位校验位
    // if (code.length === 18) {
    //     code = code.split('')
    //     // ∑(ai×Wi)(mod 11)
    //     // 加权因子
    //     var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
    //     // 校验位
    //     var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
    //     var sum = 0
    //     var ai = 0
    //     var wi = 0
    //     for (var i = 0; i < 17; i++) {
    //         ai = code[i]
    //         wi = factor[i]
    //         sum += ai * wi
    //     }
    //     // var last = parity[sum % 11]
    //     if (parity[sum % 11] !== code[17]) {
    //         tip = '校验位错误'
    //         pass = false
    //     }
    //
    // }
    if (!checkParity(code)) {
      tip = '请输入有效身份证号';
      pass = false;
    }
  }
  if (!pass) {
    callback(new Error(tip));
  } else {
    callback();
  }
};

const checkRealName = (rule, value, callback) => {
  let reg_user = /^[\u4e00-\u9fa5]{2,6}$/;
  if (value && reg_user.test(value)) {
    callback();
  } else {
    callback(new Error('姓名只能有2-6个中文字符'));
  }
};

const checkBankNo = (rule, value, callback) => {
  if (value) {
    let bankNo = value.trim();
    if (bankNo == '') {
      callback(new Error('请输入银行卡号'));
    } else if (!/^[0-9]*$/.test(value)) {
      callback(new Error('银行卡号必须全为数字'));
    } else if (bankNo.length < 16 || bankNo.length > 19) {
      callback(new Error('银行卡号长度必须在16至19之间'));
    } else {
      callback();
    }
  } else {
    callback(new Error('请输入银行卡号'));
  }
};

const nickNameLen =
  (min, max, isNeed = true) =>
  (rule, value, callback) => {
    const len = value ? value.length : 0;
    if ((len >= min && len <= max) || (!isNeed && len == 0)) {
      callback();
    } else {
      let msg = '';
      if (len < min) msg = `最少${min}个字（英文、汉字算1个字符）`;
      if (len > max) msg = `最多${max}个字（英文、汉字算1个字符）`;
      callback(new Error(msg));
    }
  };

const numberSize = (min, max) => (rule, value, callback) => {
  const num = +value;
  if (num <= max && num >= min) {
    callback();
  } else {
    let msg = '';
    if (num < min) msg = `最小值为${min}`;
    if (num > max) msg = `最大值为${max}`;
    callback(new Error(msg));
  }
};

const numberOnly = (rule, value, callback) => {
  // NaN != NaN 用于判断输入的是否是数字
  if (+value !== +value) {
    callback(new Error('请输入数字！'));
    return;
  }
  callback();
};

export default {
  time: [{ validator: validatorVideoTime, trigger: 'blur' }],
  charLen,
  mobile,
  isNum,
  tagslength,
  textLen,
  isTrue,
  checkSocialCreditCode,
  checkPhone,
  checkPhoneOrEmail,
  checkPhoneCanNull,
  checkVerCode,
  checkMobileVerCode,
  idCard,
  checkRealName,
  checkBankNo,
  nickNameLen,
  numberSize,
  numberOnly,
};
